<template>
  <el-dialog
      v-model="showCodeDialog"
      :title="messages.codeP[store.langSelect.value]"
      width="375px"
      :before-close="handleClose"
  >

    <p style="word-break: break-word; ">{{ messages.codeT[store.langSelect.value] }}</p>
    <div style="margin-top: 20px">
      <input :placeholder="messages.codeP[store.langSelect.value]" v-model="checkCode" :class="[
              !errCheckCodeClass ? 'login_form_input' : 'login_form_input_error',
            ]"/>
      <div style="margin-top: -20px; margin-bottom: 5px; height: 15px">{{ errCheckCode }}
        <span v-if="errCheckCodeClass " v-text="messages.checkCodeErr[store.langSelect.value]"> </span>
      </div>
      <Button style="width: 180px; margin-top: 20px" @click="CheckCode"
              :text="messages.checkCode[store.langSelect.value]"/>
    </div>
  </el-dialog>
</template>

<script>
import { ref, watch} from "vue";
import {useMyStorage} from "@/store/global"
import Button from "@/components/Button"
import axios from "axios";

export default {
  name: "CheckCode",
  props: {
    show: {
      type: Boolean,
      default: false
    }, checkedfn: Function
  },
  emits:['closedialog'],
  components: {
    Button
  },
  setup(props,{emit}) {
    const store = useMyStorage();
    // const showCodeDialog = ref(props.show)
  //  const test = ref(props.show)
    const showCodeDialog = ref(false)
    const checkCode = ref("")
    const email = ref("")
    const errCheckCode = ref('')
    const errCheckCodeClass = ref(false)
    const messages = {
      codeT: ["На ваш email отправлен код подтверждения. Введите его пожалуйста.\n" +
      "(Если письмо долго не приходит то, проверьте пожалуйста папку \"Спам\", особенно если у вас mail.ru)", "A verification email has been sent to your email. Please enter the code to complete registration."],
      codeP: ["Код подтверждения", "Code"],
      checkCode: ["Отправить", "Send"],
      checkCodeErr: ["Не верный код", "Incorrect code"],
    }
    watch(()=>props.show, (f) => {
      if (f === true) {
        checkCode.value = ""
        if(email.value!==""){
          showCodeDialog.value = true
        }
        const data = {
          login: store.userInfo.value.Name,
        }
        axios.post(store.ServerUrl + "/users/sendcheckcode", data)
            .then(function (response) {
              if (response.data.code === 0 && email.value==="") {
                email.value = response.data.data.email
                showCodeDialog.value = true
              }
            })

      }
    })
    const handleClose=() =>{
      showCodeDialog.value=false
      emit('closedialog', false)
    }
    const CheckCode = () => {
      axios.get(store.ServerUrl + "/users/checkcode/" + email.value + "/" + checkCode.value)
          .then(function (response) {
            if (response.data.code === 0) {
              showCodeDialog.value=false
              props.checkedfn()
            } else {
              errCheckCodeClass.value = true
              errCheckCode.value = messages.checkCodeErr[store.langSelect.value]
            }
          })
    }
    return {
      showCodeDialog,
      store,
      checkCode,
      errCheckCode,
      errCheckCodeClass,
      messages,
      CheckCode,
      handleClose
    }
  }
}
</script>

<style scoped>

</style>